<template>
  <main class="main">
      <loading-container :loading="loading" height="99">
        <div class="main__body" style="position: relative;">
          <div class="main__body-column">
                <h4>Мое юр.лицо</h4>
                <app-select :options="entities" v-model="entity" label="company_name" placeholder="Выберите организацию"/>
                <span class="text-danger text-sm entity-error" v-if="entity_error">{{ entity_error }}</span>
                <h4>Название компании или ИНН которую ищем</h4>
                <input autocomplete="off" type="text" name="search" data-vv-as=" " v-validate="'required'" data-vv-scope="form-1" v-model="search">
                <span class="text-danger text-sm">{{ errors.first('form-1.search') }}</span>
                <app-button class="mt-3 mb-4" big @click="searchCompany()">Найти</app-button>
          </div>
          <div class="main__body-column r">
            <h4>Пригласить компанию на платформу</h4>
            <input autocomplete="off" type="text" name="email" data-vv-as="email" v-validate="'required|email'" data-vv-scope="form-2" v-model="email" placeholder="Введите email компании">
              <span class="text-danger text-sm">{{ errors.first('form-2.email') }}</span>
            <app-button  class="mt-3 mb-4" big @click="sendInvite('form-2')">Отправить приглашение</app-button>
          </div>
            <loading-container :loading="loading2" height="99">
              <div class="main__body-column" :class="{right: show_result && !company}">
                  <div class="invite" v-if="show_result && !company">
                      <h3>Компания не найдена в системе. Хотите пригласить?</h3>
                      <h4>E-mail компании</h4>
                      <div class="invite-input">
                          <input autocomplete="off" type="text" name="email2" data-vv-as="email" v-validate="'required|email'" data-vv-scope="form-3" v-model="email2" placeholder="Введите email компании">
                          <app-button @click="sendInvite('form-3')" class="w-25">Пригласить</app-button>
                      </div>
                      <span class="text-danger text-sm" v-if="errors.first('form-3.email2')">{{ errors.first('form-3.email2') }}</span>

                  </div>
                  <div v-for="compan in company" :key="compan.id" style="margin-bottom: 30px">
                      <div class="contragent-container" >
                          <div class="contragent-item">
                              <div class="content">
                                  <img :src="compan.logo" v-if="compan.logo" class="icon">
                                  <p class="title">{{compan.name}}</p>
                                  <p>{{compan.about}}</p>
                                  <p class="phone">{{compan.phone}}</p>
                                  <p>{{compan.email}}</p>
                                  <p class="link">{{compan.site}}</p>
                              </div>
                          </div>
                      </div>
                      <app-button big @click="createContract(compan.user_id)">Отправить запрос на договор</app-button>
                  </div>
              </div>
            </loading-container>
        </div>
      </loading-container>
  </main>
</template>

<script>
    import AppSelect from "@/components/app-select";
    import LoadingContainer from "@/components/loading-container";
    import AppButton from "@/components/app-button";

    export default {
        name: "add",
        components: {
          AppButton,
          AppSelect,
          LoadingContainer
        },
        data: ()=>({
            entities: [],
            date: '',
            entity: '',
            search: '',
            loading: true,
            email: '',
            email2: '',
            loading2: false,
            company: '',
            show_result: false,
            entity_error: ''
        }),
        mounted() {
            this.getCompany();
        },
        methods: {
            getCompany() {
                if (localStorage.getItem('token')) {
                    this.$http.post('/get-company', {
                        token: localStorage.getItem('token')
                    }).then(({data}) => {
                        if (data.company) {
                            this.entities = data.company.entities
                        }
                    })
                    .catch((error) => {
                            console.log(error)
                    })
                    .finally(()=> this.loading = false)
                }
            },
            sendInvite(scope) {
                this.entity_error = '';
                if (this.entity) {
                    this.$validator.validateAll(scope)
                        .then(success => {
                            if(success){
                                this.$http.post( '/partner-invite',{
                                    token: localStorage.getItem('token'),
                                    email: scope == 'form-2' ? this.email : this.email2,
                                    entity: this.entity.id
                                }).then(({data}) => {
                                    if (data.success) {
                                        this.$toast.success('Запрос на регистрацию успешно отправлен!');
                                    }

                                    if (data.company) {
                                        this.company = data.company;
                                        this.show_result = true;
                                    }
                                }).catch((error) => {
                                  if (error.response.data.errors){
                                    if (error.response.data.errors.email){
                                      this.$toast.error(error.response.data.errors.email[0]);
                                    }
                                  }else{
                                    this.$toast.error('Ошибка!');
                                  }
                                })
                            }
                        })
                } else {
                    this.entity_error = 'Выберите организацию';
                }

            },
            searchCompany() {
                this.$validator.validateAll('form-1')
                    .then(success => {
                        if(success){
                            this.loading2 = true;
                            this.$http.post( '/search-company',{
                                token: localStorage.getItem('token'),
                                search: this.search
                            }).then(({data}) => {
                                this.company = data.company;
                                this.show_result = true;
                            }).catch(() => {
                                 this.$toast.error('Ошибка!');
                            })
                            .finally(()=> this.loading2 = false)
                        }
                })
            },
            createContract(user_id) {
                this.entity_error = '';
                if (this.entity) {
                    this.$http.post( '/create-contract',{
                        token: localStorage.getItem('token'),
                        entity: this.entity.id,
                        company: user_id,
                        initiator: localStorage.getItem('type')
                    }).then(({data}) => {
                        if (data.success) {
                            this.$toast.success('Запрос успешно отправлен!');
                        }
                        if (data.error) {
                            this.$toast.warning(data.error);
                        }
                    }).catch(() => {
                            this.$toast.error('Ошибка!');
                    });
                } else {
                    this.entity_error = 'Выберите организацию';
                }
            }
        }
    }
</script>

<style scoped lang="scss">
  .ml-4 {
      margin-left: 4%;
  }
  .entity-error {
      margin-top: -10px;
      display: block;
  }
  .main{
    &__body{
      display: flex;
      flex-wrap: wrap;
      &-column{
        width: 33.33%;
        margin: 8px;
        &.r{
          margin-left: auto;
          margin-right: 50px;
          position: absolute;
          top: -8px;
          right: 0px;
        }
        &.right{
          width: 60%;
          .invite{
            position: relative;
            background: #EEF0F3;
            margin-top: 50px;
            border-radius: 4px;
            padding: 20px;
            h4,h3{
              display: flex;
            }
            .link{
              color: #2CB181;
              margin-left: 10px;
              &:hover{
                text-decoration: underline;
                cursor: pointer;
              }
            }
            &-input{
              display: flex;
              align-items: center;
              justify-content: center;
              input{
                width: 75%;
                height: 40px;
                margin: 0 5px 0 0;
              }

            }
          }

        }
        h4{
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #000000;
          margin: 0 0 5px 1px;
        }
        h3{
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
          color: #2D3137;
          margin: 0 0 5px 1px;
        }
        .dis{
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #7A818F;
        }
        input{
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          color: #7A818F;
          padding-left: 10px;
          width: 100%;
          height: 40px;
          background: #FFFFFF;
          border: 1px solid #EEF0F3;
          box-sizing: border-box;
          border-radius: 4px;
          /*margin-bottom: 15px;*/
          &:disabled{
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 14px;
            color: #7A818F;
            background: #EEF0F3;
          }
        }

        .calendar{
          position: relative;
          margin-bottom: 15px;
          button{
            margin-top: 10px;
            width: 20px;
            height: 20px;
            position: absolute;
            right: 15px;
            top: 20%;
            transform: translateY(-50%);
            background-color: transparent;
            border: none;
            background-image: url('../../assets/img/main/calendar.svg');
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;
            cursor: pointer;

          }
        }
      }
    }
  }

  .contragent-item {
      background: #FFFFFF;
      box-shadow: 0px 0px 3px #E5E5EA;
      border-radius: 4px;
      max-width: 500px;
      width: 500px;
      margin: 0 15px 15px 0;
  }

    .content {
        color: #7A818F;
        font-size: 14px;
        line-height: 16px;
        font-weight: normal;
        padding: 17px 15px;
    }

    .phone {
        margin-top: 25px;
        color: #2CB181;
        font-weight: 500;
        margin-bottom: 9px;
    }

    .link {
        margin-bottom: 9px;
        color: #7A818F;
        text-decoration: underline;
    }

    .icon {
        margin-top: 15px;
        max-height: 100px;
        height: 100px;
        margin-bottom: 20px;
    }

  .title{
      height: 20px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: #2D3137;
      margin-bottom: 9px;
  }

</style>
